// @ts-ignore
import { type ApiResult } from "@utils/httpClientCore";
import { gaApiCall } from "@utils/httpClientCsrf";
// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { renderJsonWithNumbersAsBigint, parseJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import type * as schema from "@newgenerated/shared/schema";
import { serialize_AskGetabstractAnalyticsFeedbackEventForm } from "@newgenerated/shared/serializerDeserializer/AskGetabstractAnalyticsFeedbackEventForm";

export async function sendFeedback(props: { body: schema.AskGetabstractAnalyticsFeedbackEventForm }): Promise<ApiResult> {
  const path = "/gaapi/search/ask-getabstract/analytics/feedback";
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return serialize_AskGetabstractAnalyticsFeedbackEventForm(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  return { kind: "success" };
}
